import VehicleDetails from './VehicleDetails';
export default VehicleDetails;
export { default as getData } from './getData';